var Warning = require('lib/warning');

var deprecator = {
  // module for marking methods as deprecated, original method will be called, but a warning will
  // be logged with a stack trace.  Can be used without calling init (all defaults will be used),
  // or init can be called with options to override the defaults.
  // * show: determines which deprecation warnings will be outputted to the console when they happen.
  //   Possible values are 'all', 'none', and 'first'; the default value is 'first'.
  // * log: determines which deprecation warnings will be added to the deprecation warnings object.
  //   Possible values are 'all', 'none', and 'first'; the default value is 'first'.
  // * warningsParent: an object to attach the object tracking the warnings log to; default is to
  //   attach directly to the window.
  setup: false,
  options: {
    log: 'first',
    show: 'first',
    warningsParent: window
  },
  init: function(options){
    $.extend(this.options, options);
    this.deprecationWarnings = this.options.warningsParent.deprecationWarnings = {
      printAll: function () {
        var self = this;
        var i = 0;
        _.each(this, function (v, k) {
          if (typeof self[k] !== 'function') {
            self.printByName(k);
            i += self[k].length;
          }
        });
        return i + ' total warning' + (i > 1 ? 's' : '');
      },
      printByName: function (name) {
        var i = 0;
        _.each(this[name], function (w) {
          console.log(w);
          i++;
        });
        return i + ' warning' + (i > 1 ? 's' : '') + ' for ' + name;
      }
    };
    this.setup = true;
  },
  // # markBackboneFunctions
  // used to mark functions on backbone models as deprecated.
  // params:
  // * className: string of the class name
  // * ns: namespace object that the class is on
  // * nsName: string of the namespace object that the class is on (only for message to be logged)
  // * functions: array of objects defining the functions to be marked as deprecated.
  //   Each object will be used to call deprecator.mark and can define the following
  //   arguments to that function: functionName, newFunction, removalVersion
  // example:
  // * deprecator.markBackboneFunctions('Module', EF.Models, 'EF.Models', [{functionName: 'getPreviousPageByKey', removalVersion: '1.0.1'}]);
  // ** output: EF.Models.Module.getPreviousPageByKey is deprecated; no replacement; slated for removal in 1.0.1
  markBackboneFunctions: function(className, ns, nsName, functions){
    if (!this.setup) this.init();
    var classObject = ns[className];
    var classObjectWrap = classObject.extend({
      initialize: function(attrs, options){
        var self = this;
        _.each(functions, function(m){
          deprecator.mark(self, nsName + '.' + className, m.functionName, m.newFunction, m.removalVersion);
        });
        classObject.prototype.initialize.apply(this, [attrs, options]);
      }
    });
    var mod = {};
    mod[className] = classObjectWrap;
    _.extend(ns, mod);
  },
  // # mark
  // base function will still run, but a console warning generated and logged/shown according to options
  // required params:
  // * object: the object with the function to be marked
  // * objectName: name of the object, used in the message
  // * functionName: name of the function being marked
  // optional params, used to add info to the warning:
  // * newFunction: name of the replacement function
  // * removalVersion: version the function being marked is expected to be removed
  // examples:
  // * deprecator.mark(EF, 'EF', 'getModuleByKey');
  // ** output: EF.getModuleByKey is deprecated; no replacement; no removal version assigned
  // * deprecator.mark(EF, 'EF', 'getModuleByIndex', 'getModuleByFilter', '1.0.1');
  // ** output: EF.getModuleByIndex is deprecated; replacement is getModuleByFilter; slated for removal in 1.0.1
  mark: function (object, objectName, functionName, newFunction, removalVersion) {
    if (!this.setup) this.init();
    var oldFunction = object[functionName];
    var self = this;
    object[functionName] = function () {
      var message = [objectName + '.' + functionName + ' is deprecated'];
      message.push(removalVersion ? 'slated for removal in ' + removalVersion : 'no removal version assigned');
      message.push(newFunction ? 'replacement is ' + newFunction : 'no replacement');

      var warningMessage = new Warning(message.join('; ')).stack;
      if (!self.deprecationWarnings[functionName]) {
        self.deprecationWarnings[functionName] = [ ];
        if (self.options.log === 'first' || self.options.log === 'all') {
          self.deprecationWarnings[functionName].push(warningMessage);
        }
        if (self.options.show === 'first') {
          if (self.options.log === 'all') {
            warningMessage += '\nCheck deprecationWarnings for all stack traces for this method.';
          }
          console.warn(warningMessage);
        }
      } else {
        if (self.options.log === 'all') {
          self.deprecationWarnings[functionName].push(warningMessage);
        }
        if (self.options.show === 'all') {
          console.warn(warningMessage);
        }
      }

      return oldFunction.apply(object, arguments);
    };
  }
};

module.exports = deprecator;